/* eslint-env jquery */
import { Component, registerComponent } from 'js/component.js';
import { ROCKWELL_BREAKPOINTS_MAX_EM } from 'js/constants.js';

const componentName = 'quick-links';

/**
 * Quick Links
 */
class QuickLinks extends Component {

    elements = {
        container: this.element.querySelector(`.${componentName}__container`),
        mobileHeader: this.element.querySelector(`.${componentName}__mobile-header`),
        wrapper: this.element.querySelector(`.${componentName}__wrapper`),
    };

    matchMobile = window.matchMedia(`(max-width: ${ROCKWELL_BREAKPOINTS_MAX_EM.DESKTOP}em)`);

    /**
     * Initialize Mobile Dropdown
     */
    initMobileDropdown = () => {
        if (this.matchMobile.matches) {
            $(this.elements.wrapper).hide();
        } else {
            $(this.elements.wrapper).show();
        }
    };

    /**
     * Add Homepage Class to Container
     */
    initHomepageClass = () => {
        if (this.elements.container.classList.contains('homepage-design')) {
            this.element.classList.add('homepage-design');
        }
    };

    /**
     * Handle Dropdown Open/Close
     */
    toggleMobileLinks = () => {
        if (this.elements.mobileHeader.classList.contains('active')) {
            this.elements.mobileHeader.classList.remove('active');
            $(this.elements.wrapper).slideUp();
        } else {
            this.elements.mobileHeader.classList.add('active');
            $(this.elements.wrapper).slideDown();
        }
    };

    addEventListeners = () => {
        this.elements.mobileHeader.addEventListener('click', this.toggleMobileLinks);
        this.matchMobile.addEventListener('change', this.initMobileDropdown);
    };

    /**
     * Initialize Component
     */
    init() {
        if (this.elements.container.classList.contains('homepage-design')) {
            this.addEventListeners();
            this.initMobileDropdown();
            this.initHomepageClass();
        }
    }
}

registerComponent(`.${componentName}`, QuickLinks);
